
// export const UPDATE_AUTH_STATE = 'UPDATE_AUTH_STATE';
// export const UPDATE_AUTH_STATE_COMPLETE = 'UPDATE_AUTH_STATE_COMPLETE';

export const UPDATE_NETWORK_STATE = 'UPDATE_NETWORK_STATE';
export const UPDATE_NETWORK_STATE_COMPLETE = 'UPDATE_NETWORK_STATE_COMPLETE';


